import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-contact-warning',
    templateUrl: './contact-warning.component.html'
})

export class ContactWarningDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }
}
